import * as React from "react";
import { Navigate, RouteObject } from "react-router-dom";
import { Navigation } from "../types/types.ts";
import { DashboardLayout } from "../components/DashboardLayout/DashboardLayout.tsx";
import { useSelector } from "react-redux";
import { RootReducerState } from "../utils/types.ts";
import { getIsAuthComplete } from "../redux/selectors/authSelectors.ts";
import Login from "../pages/Login/Login.tsx";
import Orders from "../pages/Orders/Orders.tsx";
import Rate from "../pages/Rate/Rate.tsx";
import Loads from "../pages/Loads/Loads.tsx";
import Invoice from "../pages/Invoice/Invoice.tsx";

import {
  CLIENTHUB,
  HOME,
  INVOICE,
  LOADBOARD,
  ORDERENTRY,
  ORDERSUMMARY,
  ORDERSADMIN,
  POWERBI,
  QUOTEHISTORY,
  QUOTEREQUEST,
} from "./navigation.tsx";
import { isPageItem } from "../components/shared/navigation.tsx";
import {
  LocalShipping,
  ShoppingCart,
  InventoryRounded,
  ReceiptRounded,
} from "@mui/icons-material";

export const navigation: Navigation = [
  HOME,
  {
    kind: "page",
    segment: "orders",
    title: "Orders",
    icon: (
      <LocalShipping
        sx={{
          width: "40px",
          height: "40px",
          backgroundColor: "#FFFFFF",
          color: "#00263A",
          border: "2px solid #44D62C",
          borderRadius: "50%",
          padding: "5px",
        }}
      />
    ),
    router: {
      path: "orders",
      Component: Orders,
    },
    children: [
      {
        ...ORDERSUMMARY,
        hidden: true, // won’t appear in menu
        router: {
          index: true, // default for /orders
          Component: ORDERSUMMARY.router.Component,
        },
      },
      ORDERENTRY,
      ORDERSUMMARY,
      ORDERSADMIN,
    ],
  },
  LOADBOARD,
  {
    kind: "page",
    segment: "quotes",
    title: "Quotes",
    icon: (
      <ShoppingCart
        sx={{
          width: "40px",
          height: "40px",
          backgroundColor: "#FFFFFF",
          color: "#00263A",
          border: "2px solid #44D62C",
          borderRadius: "50%",
          padding: "5px",
        }}
      />
    ),
    router: {
      path: "quotes",
      Component: Rate,
    },
    children: [
      {
        ...QUOTEHISTORY,
        hidden: true, // won’t appear in menu
        router: {
          index: true, // default for /orders
          Component: QUOTEHISTORY.router.Component,
        },
      },
      QUOTEREQUEST,
      QUOTEHISTORY,
    ],
  },
  // {
  //   kind: "page",
  //   segment: "invoices",
  //   title: "Invoice",
  //   icon: (
  //     <ReceiptRounded
  //       sx={{
  //         width: "40px",
  //         height: "40px",
  //         backgroundColor: "#FFFFFF",
  //         color: "#00263A",
  //         border: "2px solid #44D62C",
  //         borderRadius: "50%",
  //         padding: "5px",
  //       }}
  //     />
  //   ),
  //   router: {
  //     path: "invoice",
  //     Component: Invoice,
  //   },
  //   children: [
  //     // {
  //     //   ...ORDERSUMMARY,
  //     //   hidden: true, // won’t appear in menu
  //     //   router: {
  //     //     index: true, // default for /orders
  //     //     Component: ORDERSUMMARY.router.Component,
  //     //   },
  //     // },
  //     ACCOUNTSRECIEVABLE,
  //     ACCOUNTSPAYABLE,
  //     LISTBILLREPORT,
  //     ARREPORT
  //   ],
  // },
  INVOICE,
  {
    kind: "header",
    title: "External Links",
  },
  CLIENTHUB,
  POWERBI,
];

const PrivateRoute: React.FC = () => {
  const isAuthComplete = useSelector<RootReducerState>((state) =>
    getIsAuthComplete(state),
  );

  return isAuthComplete ? <DashboardLayout /> : <Login />;
};

const Routes = (navigation: Navigation, isRoot = true): RouteObject[] => {
  const routes: RouteObject[] = isRoot
    ? [
        {
          Component: PrivateRoute,
          children: [],
        },
      ]
    : [];
  const childrenRoutes = navigation
    .filter(isPageItem) // Filter items that have a `router` property
    .map((item) => {
      const { router, children, title } = item;

      // Skip creating actual routes for external redirects
      if (item.externalRedirect) {
        return null;
      }

      const extractedItem: RouteObject = {
        ...router,
        handle: { title },
      };

      // Recursively extract components from children if they exist
      if (children) {
        extractedItem.children = Routes(children, false);
      }

      return extractedItem;
    })
    .filter(Boolean); // Filter out null routes (external redirects)

  if (isRoot) {
    routes[0].children = childrenRoutes;
    routes.push({
      path: "*",
      element: <Navigate to="/" />,
    });
  } else {
    routes.push(...childrenRoutes);
  }

  return routes;
};

const router = Routes(navigation);
export default router;
